<template>
    <TabHeader  />  
    <v-card  elevation="16" variant="outlined" class="mx-auto my-8"  style="border-color:#0a42da;border-style: solid;border-width: 0.5px;">
        <v-card-item>
       
   <v-card-text>
<v-container v-if="ecran==1">
<h2 style="color:#0a42da">Choisir le patient</h2>
<v-text-field
      v-model="search"   
      label="Rechercher"
      single-line
      hide-details
      style="background-color:#0a42da;color:white ;"
    ></v-text-field>
<v-data-table
:headers="headers"
:items="listdata"

v-model="ids"
    items-per-page="5"
show-select="id"
select-strategy="single"
:search="search"

>
       
</v-data-table>
</v-container>
<v-container v-if="ecran==2"  style="border-color: #0a42da;border-style: solid;border-width: 0.5px;">
<v-card>
<v-card-title style="color: #0a42da;">Choisir une plage de dates</v-card-title>
<v-text-field label="Date de début*" hint="Champ obligatoire" v-model="data.dateDebut" type="datetime-local"></v-text-field>
<v-text-field label="Date de fin*" hint="Champ obligatoire" type="datetime-local" v-model="data.dateFin"></v-text-field>

<v-row>


</v-row>
</v-card>
<br/>
<v-row>
<v-switch color="blue" label="Constantes" v-model="data.constantes"></v-switch>
</v-row>
<v-row>
  <v-switch color="blue" label="Observations" v-model="data.observation" ></v-switch>

</v-row>
<v-row>
  <v-switch color="blue" label="Photos" v-model="data.photos"></v-switch>

</v-row>
</v-container>
<v-container v-if="ecran==3" >
<v-row justify="center">
<iframe class="embed-responsive-item" :src="pdf" width="75%" height="800px"></iframe>
<pdf :src="pdf"></pdf>
</v-row>
</v-container>
<v-container  v-if="ecran==4"  >
<v-card>
  <v-card-title style="color:#0a42da">Saisir le mail du destinataire</v-card-title>
  <v-col
        cols="12"
        sm="8"
      >
      <v-text-field variant="outlined" label="Email" v-model="data.email" ></v-text-field>
      </v-col>
</v-card>

</v-container>


<v-container>
<v-row justify="center" class="footer">
<v-btn @click="ecran=ecran-1"       color="red-darken-4"
       class="text-none ms-4 text-white" v-if="ecran>1">precedant</v-btn>
<v-btn  color="blue-darken-4"
       class="text-none ms-4 text-white" @click="generatedPDF" :disabled="data.dateDebut==undefined ||data.dateFin==undefined" v-if="ecran==2">Générer le document</v-btn>
 <v-btn  color="blue-darken-4"
       class="text-none ms-4 text-white" @click="ecran=ecran+1" v-if="ecran!=2 && ecran!=4 &&ids!=null &&ids.length!=0">suivant</v-btn>
<v-btn v-if="ecran==4" @click="send()"  color="blue-darken-4"
       class="text-none ms-4 text-white">Envoyer</v-btn>
</v-row>
</v-container>


</v-card-text>
</v-card-item>
</v-card>

</template>
<style>
.footer {
  bottom: 0;
  position: sticky;
  height: auto;
}
</style>
<script>
import http from '../../http.js'
import TabHeader from './TabHeader.vue'
export default {
name: 'App',
components: { TabHeader },
data(){
  return {
    listdata:[],
   
     file:null,
 
      ecran:this.$route.params.id?2:1,
      pdf:null,
      ids:null,
      data:{photos:true,constantes:true,observation:true,dateFin:new Date().toLocaleString().substring(6,10)+"-"+new Date().toLocaleString().substring(3,5)+'-'+new Date().toLocaleString().substring(0,2)+"T"+new Date().toLocaleString().substring(11,19)},
      search: '',
      headers: [{ "title": "Nom", "key": "nom" }, { "title": "Prénom", "key": "prenom" }, { "title": "Prestataire", "key": "prestataire" }],
         
  }
},
mounted(){
  this.list()
},
methods:{
  list(){    
    http.get('/api/patient')
    .then(response => { this.listdata = response.data; });
  },

  precedant(){
      this.ecran=this.ecran===1?1:this.ecran-1;
  },
  suivant(){
      this.ecran=this.ecran===4?4:this.ecran+1;
  },
  getId(){
   if(this.$route.params.id){
        return this.$route.params.id;
     }
      if(this.ids[0]){
        return  this.ids[0];
     }

  },
  generatedPDF(){
    this.data.patientId=  this.getId();
    let formData = new FormData();
    formData.append('file',this.file);
    formData.append('data',JSON.stringify(this.data))
    http.       
            post('/api/generatePDF1',JSON.stringify(this.data),{ headers: {
            'Content-Type': 'application/json'}
        })
                .then(response => {
                 
                  const blob = this.base64ToBlob( response.data );
                  const url = URL.createObjectURL( blob );
                  this.data.url= response.data;
                  this.file=response.data;
                  this.pdf = url;

                    this.ecran=3;
        }).catch(e=>alert(e))
        
    },
    base64ToBlob( base64) {
      const binStr = atob( base64 );
      const len = binStr.length;
      const arr = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        arr[ i ] = binStr.charCodeAt( i );
      }
      return new Blob( [ arr ], { type: 'application/pdf' } );
      
  },
 
  async send(){    
    this.data.patient={}
    this.data.patient.id=this.data.patientId;
    delete this.data.patientId ;//refactore
    let formData = new FormData();
    formData.append('file',this.file);
    formData.append('data',JSON.stringify(this.data))

    await http.post('/api/transmission', formData)
   .then(
    alert('Le mail a été bien envoyé')  
       
   )
  .catch(error => {

    console.error('Error uploading file:', error);
})
this.$router.push('/ListTransmission');
  }
}
}
</script>
